import React, { useRef } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Stack,
  DialogActions,
  Button,
} from "@mui/material";
// import Lottie from "lottie-react";

const ScanCompDialog = ({ open, onClose, message }) => {
  //   const lottieRef = useRef();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent sx={{ pt: 10, pr: 10, pl: 10 }}>
        <Stack spacing={4}>
          <Stack alignItems="center" textAlign="center">
            <Typography variant="h6">問題が発生しました</Typography>
            <Typography variant="h6">係員にお伝えください</Typography>
          </Stack>

          <Stack alignItems="center" textAlign="center">
            <Typography variant="body1">{message}</Typography>
          </Stack>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>閉じる</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScanCompDialog;
